/* Landing-page navigation, accessible accordions, and Shopify cart submission. */
document.addEventListener('DOMContentLoaded',function(){
 document.querySelectorAll('#tp-reb-page form[data-fl-purchase]').forEach(function(form){
  form.addEventListener('submit',async function(event){
   event.preventDefault();
   var button=form.querySelector('button[type="submit"]');
   if(button.disabled)return;
   var original=button.textContent;
   var error=form.querySelector('[role="alert"]');
   if(!error){error=document.createElement('p');error.setAttribute('role','alert');error.className='fl-cart-error';form.appendChild(error);}
   error.textContent='';button.disabled=true;button.textContent='ADDING…';
   try{
    var root=window.Shopify&&Shopify.routes?Shopify.routes.root:'/';
    var response=await fetch(root+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
    var result=await response.json();
    if(!response.ok)throw new Error(result.description||'This option is currently unavailable. Please choose another package.');
    window.location.assign(root+(form.hasAttribute('data-fl-checkout')?'checkout':'cart')); 
   }catch(err){error.textContent=err.message||'Unable to add this package. Please try again.';button.disabled=false;button.textContent=original;}
  });
 });
 document.querySelectorAll('#tp-reb-page .question-header').forEach(function(header,index){
  var item=header.closest('.question-item,.question');
  var answer=item&&item.querySelector('.question-content,.answer');
  header.setAttribute('role','button');header.tabIndex=0;
  if(answer){answer.id='fl-faq-answer-'+index;header.setAttribute('aria-controls',answer.id);}
  function sync(){header.setAttribute('aria-expanded',item&&item.classList.contains('active')?'true':'false');}
  if(item)new MutationObserver(sync).observe(item,{attributes:true,attributeFilter:['class']});
  sync();header.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();header.click();}});
 });
 document.querySelectorAll('#tp-reb-page a[href="#order-now-section"]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();document.getElementById('order-now-section').scrollIntoView({behavior:'smooth'});});});
});

